import { render, staticRenderFns } from "./ModalWellDone.vue?vue&type=template&id=b0eb8a74&scoped=true&"
import script from "./ModalWellDone.vue?vue&type=script&lang=js&"
export * from "./ModalWellDone.vue?vue&type=script&lang=js&"
import style0 from "./ModalWellDone.vue?vue&type=style&index=0&id=b0eb8a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0eb8a74",
  null
  
)

export default component.exports